const Map = ({ map }) => {
  const base = 'relative w-full aspect-square'

  return (
    <div className={base}>
      <iframe
        src={map}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="w-full h-full"
      ></iframe>
    </div>
  )
}

export default Map
